import React from "react";

import EwaybillTypeNameMap from "@/map/EwaybillTypeNameMap";
import { EwaybillStatus } from "@/services/api/details";
import { ColumnsType } from "antd/lib/table";
import LogisticsCompanyNameMap from "@/map/LogisticsCompanyNameMap";

function useColumns(pageNo: number = 0, pageSize: number = 10): ColumnsType<any> {
  return [
    {
      title: "序号",
      key: "index",
      render: (waybillNo, record, index) => {
        return <div className={"noWrap colorBlack"}>{(pageNo - 1) * pageSize + index + 1}</div>;
      },
    },
    {
      title: "取号时间",
      dataIndex: "dateCreated",
      width: 200,
      render: (dateCreated, record, index) => {
        return <div className={"noWrap colorBlack"}>{dateCreated}</div>;
      },
    },
    {
      title: "电子面单账号",
      dataIndex: "type",
      key: "type",
      width: 200,
      render: (type, record, index) => {
        const ewaybillTypeName = EwaybillTypeNameMap[type];

        return <div className={"noWrap colorBlack"}>{ewaybillTypeName}</div>;
      },
    },
    {
      title: "物流公司（网点）",
      dataIndex: "logisticsCompany",
      render: (logisticsCompany, record, index) => {
        return <span>{LogisticsCompanyNameMap[logisticsCompany]}</span>;
      },
    },
    {
      title: <div className={"fw700 noWrap"}>运单号</div>,
      dataIndex: "waybillNo",
      key: "waybillNo",
      render: (waybillNo, record, index) => {
        return <div className={"noWrap colorBlack"}>{waybillNo}</div>;
      },
    },

    {
      title: <div className={"fw700 noWrap"}>订单编号</div>,
      dataIndex: "platformOrderIds",
      render: (platformOrderIds, record, index) => {
        let newOrderIds;
        if (platformOrderIds === null) {
          newOrderIds = "无";
        } else {
          newOrderIds = platformOrderIds ? platformOrderIds.split(",") : [];
          newOrderIds = newOrderIds.map(function (elm, index) {
            return (
              <div className={"colorBlack"} key={index}>
                {elm}
              </div>
            );
          });
        }
        return <div className={"colorBlack"}>{newOrderIds}</div>;
      },
    },
    {
      title: <div className={"fw700 noWrap"}>单号状态</div>,
      dataIndex: "status",
      key: "status",
      render: (status, row, index) => {
        return (
          <div className={"noWrap colorBlack"}>{status === EwaybillStatus.NORMAL ? "有效单号" : "已取消单号"}</div>
        );
      },
    },
    {
      title: "使用面单的人",
      align: "left",
      dataIndex: "consumerCompanyName",
      render: (name, row, index) => {
        return (
          <div
            className={"noWrap colorBlack"}
            style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}
          >
            <span>{row.consumerName}</span>
            <span style={{ opacity: 0.25 }}>微信：{name}</span>
          </div>
        );
      },
    },
  ];
}

export default useColumns;
